export const isValidNumberChar = value => !value || !isNaN(value);

export const hasRequiredFields = formOptions => Object.entries(formOptions).some(([key, option]) => {
  if (key === 'key' || key === 'allowTopside' || key === 'toAccount') {
    return false;
  }

  if (key === 'toAdj') {
    return !formOptions.toAccount;
  }

  return !!option;
});

export const measureElement = node => ({
  width: node.offsetWidth,
  height: node.offsetHeight,
});
